import React from 'react'
import type { TopicListFragment } from '../../../.graphql/generated-types'
import { notEmpty } from '@marketing-sites/utils'
import { ComposeComponentTopic } from '../ComposeComponentTopic'

export interface ComposeComponentTopicListProps {
  data: TopicListFragment
}

export function ComposeComponentTopicList({
  data,
}: ComposeComponentTopicListProps) {
  if (data.name && data.topicsCollection?.items) {
    const items = data.topicsCollection.items.filter(notEmpty)

    return (
      <div className="grid auto-rows-fr grid-cols-3 justify-items-stretch gap-4 pt-4 md:grid-cols-6">
        {items.map((topic, i) => (
          <ComposeComponentTopic key={i} data={topic} />
        ))}
      </div>
    )
  }
  return null
}
